import { useEffect, useState } from "react";
import { Story } from "@/types/story";
import { supabase } from "@/integrations/supabase/client";
import { Avatar } from "./ui/avatar";
import { Card } from "./ui/card";

const StoriesFeed = () => {
  const [stories, setStories] = useState<Story[]>([]);

  useEffect(() => {
    const fetchStories = async () => {
      const { data, error } = await supabase
        .from("stories")
        .select("*")
        .order("created_at", { ascending: false });

      if (error) {
        console.error("Error fetching stories:", error);
        return;
      }

      if (data) {
        setStories(data as Story[]);
      }
    };

    fetchStories();
  }, []);

  if (stories.length === 0) {
    return null;
  }

  return (
    <div className="col-span-12 mt-6">
      <h2 className="text-2xl font-semibold mb-4">Recent Stories</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {stories.map((story) => (
          <Card key={story.id} className="p-4 hover:shadow-lg transition-shadow">
            <div className="flex items-center gap-3 mb-3">
              <Avatar>
                <img
                  src={story.user_avatar_url || "/default-avatar.png"}
                  alt={story.user_name}
                  className="w-10 h-10 rounded-full"
                />
              </Avatar>
              <div>
                <h3 className="font-medium">{story.user_name}</h3>
                <p className="text-sm text-gray-500">
                  {new Date(story.created_at || "").toLocaleDateString()}
                </p>
              </div>
            </div>
            {story.title && <h4 className="font-medium mb-2">{story.title}</h4>}
            {story.content && <p className="text-gray-600">{story.content}</p>}
          </Card>
        ))}
      </div>
    </div>
  );
};

export default StoriesFeed;